import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {$agentFactory} from "../../$agent.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class AgentPreferencesCtrl implements IController {

  agent: AgentModel;
  preferences: any;
  billingAccount: any;

  public agentCopy: any;
  public preferencesCopy: any;

  public isSaveAgent?: boolean;
  public isSavePreferences?: boolean;

  private agentRef: any;
  private shipperAccounts: any;
  private registrationStatuses: any;
  private agentSelectedTimeZone: any;
  private agreements: any;

  public isSaveAvailable: boolean;

  constructor(private $agent: $agentFactory, private commonsAlertsService: CommonsAlertsService, private agentRequests: AgentRequests,
              private bringozLoaderService: BringozLoaderService, private $log, private agentDialogService: AgentDialogService) {
  }

  $onInit() {
    this.agentRef = this.$agent(this.agent.id);

    this.agentCopy = angular.copy(this.agent);
    this.preferencesCopy = angular.copy(this.preferences);

    this.shipperAccounts = [];
    this.registrationStatuses = [
      'Created',
      'CompletePersonal',
      'CompleteRequirements',
      'Approved'
    ];
    this.agentSelectedTimeZone = _.get(this.preferences, 'zoneId') || undefined;

    this.agentRequests.getAgreements(this.agent.id)
      .then((agreements) => {
        this.agreements = agreements;
      })
      .catch((error) => {
        this.$log.error('Error getting agreements from server, @agentPreferences \n' + error);
      })
  }

  onSelectSpecializationVerticals(selectedVerticals) {
    this.preferencesCopy.priorityVerticals = selectedVerticals
    this.onSaveActive();
  }

  onSelectSpecializationPriorities(ids) {
    this.preferencesCopy.priorityIds = ids
    this.onSaveActive();
  }

  onSelectRestrictionsVerticals(selectedVerticals) {
    this.preferencesCopy.restrictedVerticals = selectedVerticals
    this.onSaveActive();
  }

  onSelectRestrictionsPriorities(ids) {
    this.preferencesCopy.restrictedIds = ids;
    this.onSaveActive();
  }

  onEditRouteCost() {
    this.agentDialogService.editAgentRouteCostValue(this.preferences)
      .then((preferences) => {
        this.onSaveActive();
      })
  }

  onSaveActive() {
    this.isSaveAgent = !_.isEqual(this.agentCopy, this.agent);
    this.isSavePreferences = !_.isEqual(this.preferencesCopy, this.preferences);
  }

  onSave() {
    if (this.isSaveAgent)  {
      this.onSaveAgent();
    }
    if (this.isSavePreferences) {
      this.onSavePreferences();
    }
  }

  onCancelChanges() {
    if(this.isSaveAgent) {
      this.agentCopy = angular.copy(this.agent);
      this.isSaveAgent = false;
    }

    if(this.isSavePreferences) {
      this.preferencesCopy = angular.copy(this.preferences);
      this.isSavePreferences = false;
    }
  }

  onSavePreferences() {
    this.bringozLoaderService.on();
    this.agentRequests.setAgentPreferences(this.preferencesCopy, this.agent.id)
      .then((preferences) => {
        this.preferences = preferences;
        this.preferencesCopy = angular.copy(preferences);
        this.isSavePreferences = false;
        this.commonsAlertsService.preferencesUpdateSuccess();
      })
      .catch((error) => {
        this.commonsAlertsService.preferencesError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onSaveAgent() {
    this.bringozLoaderService.on();
    this.agentRef.$update(this.agentCopy)
      .then((agent) => {
        this.agent = agent;
        this.agentCopy = angular.copy(agent);
        this.isSaveAgent = false;
        this.commonsAlertsService.preferencesUpdateSuccess();
      })
      .catch((error) => {
        this.commonsAlertsService.preferencesError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentPreferences', {
    bindings: {
      agent: '<',
      preferences: '<',
      billingAccount: '<'
    },
    template: require('./agent-preferences.html').default,
    controller: AgentPreferencesCtrl
  });
